var exports = {
  "Pu": "IssueLabelToken__0H-m6r",
  "IM": "archivedIcon__6ud3yr",
  "Sk": "archivedIconGlyph__lqQ_l3",
};

module.exports = exports;
